// ============================================================
// AUTO-TRANSLATION DICTIONARY (English → Arabic)
// Used for: country names, processes, tasting notes, drink names
// ============================================================
const TRANSLATIONS = {
  // ===== COUNTRIES =====
  'ethiopia': 'اثيوبيا',
  'kenya': 'كينيا',
  'colombia': 'كولومبيا',
  'brazil': 'برازيل',
  'guatemala': 'غواتيمالا',
  'costa rica': 'كوستاريكا',
  'panama': 'باناما',
  'rwanda': 'رواندا',
  'burundi': 'بوروندي',
  'yemen': 'يمن',
  'el salvador': 'السلفادور',
  'honduras': 'هندوراس',
  'nicaragua': 'نيكاراغوا',
  'mexico': 'مكسيك',
  'peru': 'بيرو',
  'ecuador': 'الإكوادور',
  'bolivia': 'بوليفيا',
  'tanzania': 'تنزانيا',
  'uganda': 'أوغندا',
  'india': 'الهند',
  'indonesia': 'إندونيسيا',
  'vietnam': 'فيتنام',
  'thailand': 'تايلاند',
  'china': 'الصين',
  'jamaica': 'جامايكا',
  'haiti': 'هايتي',
  'dominican republic': 'جمهورية الدومينيكان',
  'cuba': 'كوبا',
  'papua new guinea': 'بابوا غينيا الجديدة',
  'sumatra': 'سومطرة',
  'java': 'جاوة',
  'sulawesi': 'سولاويسي',

  // ===== PROCESSES =====
  'washed': 'مغسولة',
  'natural': 'طبيعية',
  'honey': 'عسلية',
  'anaerobic': 'لاهوائي',
  'anaerobic natural': 'طبيعي لاهوائي',
  'anaerobic washed': 'مغسول لاهوائي',
  'semi washed': 'نصف مغسول',
  'wet hulled': 'منزوع رطب',
  'carbonic maceration': 'تخمير كاربوني',
  'lactic fermentation': 'تخمير لبني',
  'thermal shock': 'صدمة حرارية',
  'extended fermentation': 'تخمير ممتد',
  'red honey': 'هاني أحمر',
  'yellow honey': 'هاني أصفر',
  'black honey': 'هاني أسود',
  'white honey': 'هاني أبيض',

  // ===== TASTING NOTES =====
  'jasmine': 'ياسمين',
  'bergamot': 'برغموت',
  'lemon': 'ليمون',
  'lemon zest': 'قشر ليمون',

  // ===== FLAVOR NOTES (expanded) =====
  'almond': 'لوز',
  'apricot': 'مشمش',
  'berries': 'توت',
  'berries jam': 'مربى التوت',
  'blackberry': 'توت أسود',
  'brown sugar': 'سكر بني',
  'caramel': 'كراميل',
  'chocolate': 'شوكولاتة',
  'cinamon': 'قرفة',
  'cinnamon': 'قرفة',
  'cocoa': 'كاكاو',
  'dark chocolate': 'شوكولاتة داكنة',
  'dark fruit': 'فواكه داكنة',
  'figs': 'تين',
  'fig': 'تين',
  'floral': 'زهري',
  'hazelnut': 'بندق',
  'honeysuckle': 'صريمة الجدي',
  'lychee': 'ليتشي',
  'lychey': 'ليتشي',
  'mandarin': 'يوسفي',
  'milky chocolate': 'شوكولاتة بالحليب',
  'mix berries': 'توت مشكّل',
  'mixed berries': 'توت مشكّل',
  'nuts': 'مكسرات',
  'nutty': 'نكهة المكسرات',
  'orange': 'برتقال',
  'peach': 'خوخ',
  'plum': 'برقوق',
  'raisins': 'زبيب',
  'raspberry': 'توت العليق',
  'red apple': 'تفاح أحمر',
  'red fruit': 'فواكه حمراء',
  'red fruits': 'فواكه حمراء',
  'rose-water': 'ماء الورد',
  'rose water': 'ماء الورد',
  'rosewater': 'ماء الورد',
  'stone fruit': 'فواكه ذات نواة',
  'strawberry': 'فراولة',
  'tropical': 'فواكه استوائية',
  'white tea': 'شاي أبيض',
    // ===== FLAVOR NOTES (reserve additions) =====
  'prunes': 'برقوق مجفف',
  'prune': 'برقوق مجفف',
  'sugar cane': 'قصب السكر',
  'nectarin': 'نكتارين',
  'nectarine': 'نكتارين',
  'currant': 'كشمش',
  'red grape': 'عنب أحمر',
  'grape': 'عنب',
  'milk chocolate': 'شوكولاتة بالحليب',

  // ===== COFFEE NAMES (phonetic) =====
  'bossa nova': 'بوسا نوفا',
  'milky way': 'ميلكي واي',
  'buenos dias': 'بوينوس دياس',
  'shereen': 'شيرين',
  'decaf': 'ديكاف',
  'yirga red': 'يرقا ريد',
  'lizaraso typica-bourbon': 'ليزاراسو تيبيكا-بوربون',
  'lizaraso typica bourbon': 'ليزاراسو تيبيكا-بوربون',
  'ama ruby lot 1': 'أما روبي لوت ١',
  'la primavera pink bourbon': 'لا بريمافيرا بينك بوربون',
  'chelchele': 'تشيلتشيلي',
  'juan sinchi': 'خوان سينتشي',
  'la papaya': 'لا بابايا',
  'supernatural karibu': 'سوبرناتشورال كاريبو',
  'guayata': 'غوايتا',
  'milagro geisha': 'ميلاغرو غيشا',
  'afterglow geisha': 'أفترغلو غيشا',
  'ama lilac lot 2': 'أما لايلاك لوت ٢',
  'bani ismail': 'بني اسماعيل',
  'cumbia': 'كومبيا',
  'lime': 'لايم',
  'orange': 'برتقال',
  'tangerine': 'يوسفي',
  'grapefruit': 'جريب فروت',
  'peach': 'خوخ',
  'apricot': 'مشمش',
  'apple': 'تفاح',
  'red apple': 'تفاح أحمر',
  'green apple': 'تفاح أخضر',
  'pear': 'كمثرى',
  'strawberry': 'فراولة',
  'raspberry': 'توت العليق',
  'blueberry': 'توت أزرق',
  'blackberry': 'توت أسود',
  'blackcurrant': 'كشمش أسود',
  'cherry': 'كرز',
  'plum': 'برقوق',
  'grape': 'عنب',
  'pineapple': 'أناناس',
  'mango': 'مانجو',
  'tropical fruit': 'فاكهة استوائية',
  'stone fruit': 'ستون فروت',
  'dried berry': 'توت مجفف',
  'dried fruit': 'فاكهة مجففة',
  'date': 'تمر',
  'fig': 'تين',
  'raisin': 'زبيب',
  'honeysuckle': 'صريمة الجدي',
  'caramel': 'كراميل',
  'toffee': 'توفي',
  'butterscotch': 'باترسكوتش',
  'brown sugar': 'سكر بني',
  'molasses': 'دبس',
  'maple syrup': 'شراب القيقب',
  'vanilla': 'فانيلا',
  'chocolate': 'شوكولاتة',
  'milk chocolate': 'شوكولاتة بالحليب',
  'dark chocolate': 'شوكولاتة داكنة',
  'cocoa': 'كاكاو',
  'cocoa nibs': 'حبيبات كاكاو',
  'hazelnut': 'بندق',
  'almond': 'لوز',
  'walnut': 'جوز',
  'peanut': 'فول سوداني',
  'pecan': 'بيكان',
  'cashew': 'كاجو',
  'black tea': 'شاي أسود',
  'green tea': 'شاي أخضر',
  'earl grey': 'إيرل غراي',
  'floral': 'زهري',
  'rose': 'ورد',
  'lavender': 'لافندر',
  'hibiscus': 'كركديه',
  'wine': 'نبيذ',
  'red wine': 'نبيذ أحمر',
  'spice': 'بهارات',
  'spicy': 'حار',
  'cinnamon': 'قرفة',
  'clove': 'قرنفل',
  'cardamom': 'هيل',
  'nutmeg': 'جوزة الطيب',
  'tobacco': 'تبغ',
  'malt': 'شعير',
  'cream': 'كريمة',
  'buttery': 'زبدي',
  'syrupy': 'شرابي',
  'juicy': 'عصاري',
  'silky': 'حريري',
  'smooth': 'ناعم',
  'bright': 'مشرق',
  'clean': 'نظيف',
  'complex': 'معقد',
  'balanced': 'متوازن',
  'sweet': 'حلو',

  // ===== DRINK NAMES =====
  'espresso': 'اسبريسو',
  'doppio': 'دوبيو',
  'macchiato': 'ماكياتو',
  'americano': 'أمريكانو',
  'long black': 'لونق بلاك',
  'cortado': 'كورتادو',
  'flat white': 'فلات وايت',
  'cappuccino': 'كابتشينو',
  'latte': 'لاتيه',
  'spanish latte': 'اسبانيش لاتيه',
  'mocha': 'موكا',
  'house batch': 'باتش هاوس',
  'single origin batch': 'باتش سنقل اوريجن',
  'classic cold brew': 'كولد برو كلاسيك',
  'cold brew tonic': 'كولد برو تونك',
  'cold brew float': 'كولد برو فلوت',
  'nitro cold brew': 'نايترو كولد برو',
  'cold brew': 'كولد برو',
  'iced latte': 'لاتيه بارد',
  'iced americano': 'أمريكانو بارد',
  'v60': 'في 60',
  'chemex': 'كيمكس',
  'aeropress': 'إيروبرس',
  'french press': 'فرنش برس'
};

// ============================================================
// AUTO-TRANSLATE FUNCTION
// Best-effort translation; preserves untranslatable parts
// ============================================================
// Context-specific overrides: same English word may translate differently depending on context
const CONTEXT_OVERRIDES = {
  notes: {
    // In tasting notes, "honey" means the flavor
    'honey': 'عسل'
  }
};

function autoTranslate(englishText, context) {
  if (!englishText) return '';
  const text = String(englishText).trim();
  const lower = text.toLowerCase();
  const overrides = (context && CONTEXT_OVERRIDES[context]) || {};

  // Direct match (full string) — check overrides first
  if (overrides[lower]) return overrides[lower];
  if (TRANSLATIONS[lower]) return TRANSLATIONS[lower];

  // For multi-part strings (e.g. "Jasmine, Bergamot, Lemon"), translate parts
  if (text.includes(',')) {
    const parts = text.split(',').map(p => p.trim());
    const translated = parts.map(part => {
      const partLower = part.toLowerCase();
      if (overrides[partLower]) return overrides[partLower];
      if (TRANSLATIONS[partLower]) return TRANSLATIONS[partLower];
      return tryCompoundMatch(part) || part;
    });
    return translated.join('، ');
  }

  return tryCompoundMatch(text) || text;
}

function tryCompoundMatch(text) {
  const lower = text.toLowerCase().trim();
  if (TRANSLATIONS[lower]) return TRANSLATIONS[lower];

  // Try removing last word, then last 2 words (for things like "Ethiopia Yirgacheffe")
  const words = lower.split(/\s+/);
  if (words.length > 1) {
    // Try first word(s) translation + remaining as-is
    for (let i = words.length - 1; i >= 1; i--) {
      const prefix = words.slice(0, i).join(' ');
      if (TRANSLATIONS[prefix]) {
        const remaining = words.slice(i).join(' ');
        // Capitalize remaining (proper noun)
        const remainingCap = remaining.split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
        return TRANSLATIONS[prefix] + ' ' + remainingCap;
      }
    }
  }
  return null;
}

/* ===== block ===== */

// ============================================================
// COUNTRY MAP SVG VECTORS
// Simplified outlines drawn as SVG paths
// All viewBox 0 0 100 100 for consistent scaling
// ============================================================
const COUNTRY_MAPS = {
  ethiopia: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M20,40 L25,30 L35,25 L48,22 L60,25 L72,30 L80,38 L82,48 L78,58 L72,65 L65,72 L55,75 L45,73 L35,68 L28,60 L22,52 Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="50" cy="48" r="2.5" fill="currentColor"/></svg>`,

  kenya: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M25,35 L40,28 L58,25 L72,30 L78,42 L75,55 L70,68 L62,75 L52,76 L42,72 L32,65 L25,55 L22,45 Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="48" cy="50" r="2.5" fill="currentColor"/></svg>`,

  colombia: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M30,20 L42,18 L55,22 L65,30 L72,42 L75,55 L70,68 L62,75 L50,78 L40,72 L32,62 L28,50 L26,38 L28,28 Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="50" cy="48" r="2.5" fill="currentColor"/></svg>`,

  brazil: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M25,28 L40,22 L58,20 L72,25 L82,35 L85,48 L82,60 L75,72 L62,80 L48,82 L35,78 L25,68 L20,55 L18,42 L20,32 Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="50" cy="50" r="2.5" fill="currentColor"/></svg>`,

  guatemala: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M22,38 L32,30 L45,28 L58,32 L70,38 L78,45 L75,55 L65,60 L52,62 L40,58 L30,52 L24,45 Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="50" cy="45" r="2.5" fill="currentColor"/></svg>`,

  'costa rica': `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M20,50 L30,42 L42,38 L55,38 L68,42 L78,50 L82,58 L72,62 L60,62 L48,60 L35,55 L25,55 Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="52" cy="50" r="2.5" fill="currentColor"/></svg>`,

  panama: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M15,52 L25,45 L40,42 L55,42 L70,45 L82,50 L85,58 L75,62 L62,62 L48,60 L33,58 L20,58 Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="50" cy="52" r="2.5" fill="currentColor"/></svg>`,

  rwanda: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M30,35 L42,28 L58,28 L72,35 L75,48 L72,60 L60,68 L48,68 L35,62 L28,52 L28,42 Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="50" cy="48" r="2.5" fill="currentColor"/></svg>`,

  burundi: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M32,32 L45,28 L60,30 L70,38 L72,52 L65,65 L52,70 L38,65 L30,55 L28,42 Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="50" cy="48" r="2.5" fill="currentColor"/></svg>`,

  yemen: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M15,40 L28,32 L45,28 L62,28 L78,32 L85,42 L82,55 L72,62 L58,65 L42,62 L28,58 L18,52 Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="50" cy="48" r="2.5" fill="currentColor"/></svg>`,

  'el salvador': `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M22,48 L35,42 L50,40 L65,42 L78,48 L82,55 L72,60 L58,62 L45,60 L32,58 L24,55 Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="52" cy="50" r="2.5" fill="currentColor"/></svg>`,

  honduras: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M20,42 L35,35 L52,32 L68,35 L82,42 L85,52 L75,58 L60,60 L45,58 L30,55 L22,50 Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="52" cy="48" r="2.5" fill="currentColor"/></svg>`,

  nicaragua: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M25,35 L38,30 L55,30 L70,35 L80,45 L78,58 L68,65 L52,68 L38,65 L28,58 L22,48 Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="50" cy="50" r="2.5" fill="currentColor"/></svg>`,

  mexico: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M15,32 L30,28 L45,30 L60,32 L72,38 L82,45 L85,55 L75,62 L62,68 L48,65 L35,58 L25,52 L18,45 Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="55" cy="50" r="2.5" fill="currentColor"/></svg>`,

  peru: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M25,22 L38,20 L52,25 L65,32 L75,42 L80,55 L75,68 L65,78 L52,82 L40,78 L30,70 L22,58 L20,42 L22,30 Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="48" cy="50" r="2.5" fill="currentColor"/></svg>`,

  ecuador: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M25,38 L38,32 L52,30 L65,32 L78,38 L82,48 L78,58 L65,65 L52,68 L38,65 L28,58 L22,48 Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="50" cy="50" r="2.5" fill="currentColor"/></svg>`,

  bolivia: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M25,30 L40,25 L55,25 L70,30 L80,40 L82,52 L75,65 L62,72 L48,72 L35,68 L25,58 L20,45 Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="50" cy="50" r="2.5" fill="currentColor"/></svg>`,

  tanzania: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M22,32 L38,28 L55,28 L72,32 L82,42 L82,55 L75,68 L62,72 L45,72 L30,68 L22,58 L20,45 Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="50" cy="50" r="2.5" fill="currentColor"/></svg>`,

  uganda: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M25,32 L40,28 L55,30 L70,35 L78,45 L78,58 L68,68 L55,72 L42,68 L30,62 L24,52 Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="50" cy="50" r="2.5" fill="currentColor"/></svg>`,

  india: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M25,25 L40,22 L55,25 L70,32 L78,42 L75,55 L65,68 L52,80 L42,82 L35,72 L28,60 L22,48 L20,35 Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="48" cy="55" r="2.5" fill="currentColor"/></svg>`,

  indonesia: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M10,48 L22,45 L35,47 L48,45 L60,48 L72,46 L85,48 L88,55 L78,58 L65,57 L52,58 L38,57 L25,58 L12,55 Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="35" cy="52" r="2" fill="currentColor"/><circle cx="65" cy="52" r="2" fill="currentColor"/></svg>`,

  vietnam: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M40,18 L48,20 L55,28 L60,42 L65,55 L62,68 L52,78 L42,82 L35,75 L32,62 L35,48 L38,32 Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="48" cy="50" r="2.5" fill="currentColor"/></svg>`,

  jamaica: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><ellipse cx="50" cy="50" rx="32" ry="14" fill="none" stroke="currentColor" stroke-width="1.5"/><circle cx="50" cy="50" r="2.5" fill="currentColor"/></svg>`,

  cuba: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M15,52 L28,45 L42,46 L55,48 L70,46 L82,48 L85,55 L70,58 L55,57 L42,58 L28,57 L18,58 Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="50" cy="52" r="2.5" fill="currentColor"/></svg>`,

  'papua new guinea': `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path d="M15,42 L28,38 L42,40 L55,38 L68,42 L80,45 L85,55 L72,58 L58,57 L45,58 L32,55 L18,52 Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="50" cy="48" r="2.5" fill="currentColor"/></svg>`
};

function getCountryMap(countryName) {
  if (!countryName) return null;
  const key = String(countryName).toLowerCase().trim();
  return COUNTRY_MAPS[key] || null;
}

/* ===== block ===== */

// Brewing method icons - 3 simple categories
const BREW_ICONS = {
  // Espresso - small ceramic cup with handle, steam wisps
  espresso: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M28 50 L28 72 Q28 80 36 80 L60 80 Q68 80 68 72 L68 50 Z"/>
    <path d="M68 56 Q78 56 78 64 Q78 72 68 72"/>
    <line x1="28" y1="58" x2="68" y2="58"/>
    <path d="M40 38 Q42 32 40 26 Q38 22 40 18"/>
    <path d="M50 38 Q52 32 50 26 Q48 22 50 18"/>
    <path d="M60 38 Q62 32 60 26 Q58 22 60 18"/>
  </svg>`,

  // Filter / V60 / Pour-over - cone dripper above carafe
  filter: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M22 22 L78 22 L58 54 L42 54 Z"/>
    <line x1="50" y1="54" x2="50" y2="64"/>
    <path d="M30 64 L70 64 L70 84 Q70 88 66 88 L34 88 Q30 88 30 84 Z"/>
    <line x1="34" y1="68" x2="66" y2="68"/>
    <path d="M40 16 Q42 12 40 8" stroke-width="1.8"/>
    <path d="M50 16 Q52 12 50 8" stroke-width="1.8"/>
    <path d="M60 16 Q62 12 60 8" stroke-width="1.8"/>
  </svg>`,

  // Cold brew - tall glass with ice cubes and straw
  cold: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M32 22 L68 22 L64 86 Q64 90 60 90 L40 90 Q36 90 36 86 Z"/>
    <line x1="42" y1="14" x2="46" y2="34"/>
    <rect x="42" y="34" width="12" height="12" rx="1.5"/>
    <rect x="50" y="50" width="11" height="11" rx="1.5"/>
    <rect x="40" y="62" width="11" height="11" rx="1.5"/>
  </svg>`
};

// Map every category to one of the 3 icons (automatic, no manual override)
function getBrewIcon(item) {
  const map = {
    'Black Coffee': 'espresso',
    'White Coffee': 'espresso',
    'Black Single Origin': 'espresso',
    'White Single Origin': 'espresso',
    'Filter Reserve': 'filter',
    'Batch Brew': 'filter',
    'Cold Brew': 'cold'
  };
  const key = map[item.category] || 'espresso';
  return BREW_ICONS[key];
}

/* ===== block ===== */

// ============================================================
// 48 EAST CAFE MENU — LIVE (customer-facing, read-only)
// Reads published menu from JSONBin, branch toggle, smart rendering
// ============================================================

// --- CONFIG (filled at build / via window.LIVE_CONFIG) ---
const LIVE_CONFIG = window.LIVE_CONFIG || {
  jsonbinId: '6a12c04b6610dd3ae8989dd9',
  jsonbinAccessKey: '$2a$10$q0WheCJb6HbfknqbykD3UO7IPR9Ks1f150ip7/K.kr7iZBlXSthmm'
};

const JSONBIN_BASE = 'https://api.jsonbin.io/v3/b';

const BRANCHES = [
  { id: 'shuwaikh', nameEn: 'Shuwaikh', nameAr: 'الشويخ' },
  { id: 'salmiya', nameEn: 'Salmiya', nameAr: 'السالمية' },
  { id: 'zain', nameEn: 'Zain', nameAr: 'زين' },
  { id: 'codded', nameEn: 'Coded', nameAr: 'كوديد' },
  { id: 'bait_ahmad', nameEn: 'Bait Ahmad', nameAr: 'بيت أحمد' },
  { id: 'sirra_cafe', nameEn: 'Surra Cafe', nameAr: 'السرة كافيه' }
];
function branchById(id) { return BRANCHES.find(b => b.id === id); }

// Category order + which categories are "detailed" (show full info)
const CATEGORY_ORDER = [
  'Black Coffee', 'White Coffee',
  'Black Single Origin', 'White Single Origin',
  'Filter Reserve', 'Batch Brew', 'Cold Brew'
];
const CATEGORY_AR = {
  'Black Coffee': 'قهوة سوداء',
  'White Coffee': 'قهوة بالحليب',
  'Black Single Origin': 'سنجل أوريجن سوداء',
  'White Single Origin': 'سنجل أوريجن بالحليب',
  'Filter Reserve': 'فلتر ريزيرف',
  'Batch Brew': 'باتش برو',
  'Cold Brew': 'كولد برو'
};
const DETAILED_CATS = ['Black Single Origin', 'White Single Origin', 'Filter Reserve'];

// --- STATE ---
let allBranches = {};   // { shuwaikh: {items,...}, ... }
let currentBranch = localStorage.getItem('48east_live_branch') || 'shuwaikh';

// --- FETCH FROM JSONBIN ---
async function fetchLive() {
  if (!LIVE_CONFIG.jsonbinId || LIVE_CONFIG.jsonbinId.indexOf('__') === 0) {
    return null; // not configured
  }
  try {
    const headers = LIVE_CONFIG.jsonbinAccessKey && LIVE_CONFIG.jsonbinAccessKey.indexOf('__') !== 0
      ? { 'X-Access-Key': LIVE_CONFIG.jsonbinAccessKey } : {};
    const res = await fetch(`${JSONBIN_BASE}/${LIVE_CONFIG.jsonbinId}/latest`, { headers, cache: 'no-store' });
    if (!res.ok) throw new Error('Fetch failed: ' + res.status);
    const data = await res.json();
    return (data.record && data.record.branches) ? data.record.branches : {};
  } catch (err) {
    console.error('Live fetch error:', err);
    return null;
  }
}

// --- HELPERS ---
function escapeHtml(s) {
  const map = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  return String(s).replace(/[&<>"']/g, c => map[c]);
}
function capNotes(text) {
  if (!text) return '';
  return String(text).split(',').map(p => {
    const s = p.trim();
    return s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
  }).join(', ');
}
function arSpan(text) {
  return '<span style="letter-spacing:normal;text-transform:none;font-family:\'Helvetica Neue Arabic\',sans-serif;">' + text + '</span>';
}

// --- RENDER BRANCH TOGGLE ---
function renderBranchToggle() {
  const container = document.getElementById('branchToggle');
  container.innerHTML = '';
  for (const b of BRANCHES) {
    // Only show branches that have a published menu
    const hasMenu = allBranches[b.id] && allBranches[b.id].items && allBranches[b.id].items.length > 0;
    if (!hasMenu && b.id !== currentBranch) continue;
    const btn = document.createElement('button');
    btn.className = 'branch-toggle-btn' + (b.id === currentBranch ? ' active' : '');
    btn.dataset.branch = b.id;
    btn.innerHTML = '<span class="bt-en">' + b.nameEn + '</span><span class="bt-ar">' + b.nameAr + '</span>';
    if (!hasMenu) { btn.disabled = true; btn.style.opacity = '0.35'; }
    btn.addEventListener('click', () => {
      if (b.id === currentBranch) return;
      currentBranch = b.id;
      localStorage.setItem('48east_live_branch', b.id);
      renderBranchToggle();
      renderMenu();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    container.appendChild(btn);
  }
}

// --- RENDER MENU ---
function renderMenu() {
  const menuEl = document.getElementById('menu');
  const branchData = allBranches[currentBranch];
  const items = (branchData && branchData.items) || [];

  if (items.length === 0) {
    menuEl.innerHTML = '<div class="empty-menu">'
      + '<div class="empty-menu-icon">☕</div>'
      + '<div class="empty-menu-title">Menu coming soon</div>'
      + '<div class="empty-menu-sub">' + arSpan('المنيو قيد التحديث') + '</div>'
      + '</div>';
    return;
  }

  // Group by category
  const byCat = {};
  for (const item of items) {
    if (!byCat[item.category]) byCat[item.category] = [];
    byCat[item.category].push(item);
  }

  let html = '';
  for (const cat of CATEGORY_ORDER) {
    const catItems = byCat[cat];
    if (!catItems || catItems.length === 0) continue;
    const isDetailed = DETAILED_CATS.includes(cat);

    html += '<section class="cat-section">';
    html += '<div class="cat-header">';
    html += '<h2 class="cat-title">' + escapeHtml(cat) + '</h2>';
    html += '<span class="cat-title-ar">' + arSpan(CATEGORY_AR[cat] || '') + '</span>';
    html += '</div>';

    if (isDetailed) {
      html += '<div class="cards-grid">';
      for (const item of catItems) html += renderDetailedCard(item);
      html += '</div>';
    } else {
      html += '<div class="simple-list">';
      for (const item of catItems) html += renderSimpleRow(item);
      html += '</div>';
    }
    html += '</section>';
  }

  menuEl.innerHTML = html;
}

// Simple row: name + AR + price (for Black/White Coffee, Batch, Cold)
function renderSimpleRow(item) {
  const nameAr = item.nameAr || (typeof autoTranslate === 'function' ? autoTranslate(item.nameEn) : '');
  const showAr = nameAr && nameAr !== item.nameEn;
  const price = item.priceSingle != null ? Number(item.priceSingle).toFixed(3) : '';
  let h = '<div class="simple-row">';
  h += '<div class="simple-row-info">';
  h += '<span class="simple-row-name">' + escapeHtml(item.nameEn) + '</span>';
  if (showAr) h += '<span class="simple-row-name-ar">' + arSpan(escapeHtml(nameAr)) + '</span>';
  h += '</div>';
  if (price) h += '<span class="simple-row-price">' + price + '</span>';
  h += '</div>';
  return h;
}

// Detailed card: full info for Single Origin / Filter Reserve
function renderDetailedCard(item) {
  const originAr = item.origin && typeof autoTranslate === 'function' ? autoTranslate(item.origin) : '';
  const processAr = item.process && typeof autoTranslate === 'function' ? autoTranslate(item.process) : '';
  const notesAr = item.notes && typeof autoTranslate === 'function' ? autoTranslate(item.notes, 'notes') : '';
  const brewIcon = typeof getBrewIcon === 'function' ? getBrewIcon(item) : '';
  const mapSvg = item.origin && typeof getCountryMap === 'function' ? getCountryMap(item.origin) : '';
  const price = item.priceSingle != null ? Number(item.priceSingle).toFixed(3) : '';

  let h = '<div class="coffee-card">';

  // Map watermark
  if (mapSvg) {
    h += '<div class="card-map">' + mapSvg + '</div>';
  }
  // Brew icon
  if (brewIcon) {
    h += '<div class="card-icon">' + brewIcon + '</div>';
  }

  h += '<div class="card-body">';

  // Name
  h += '<div class="card-name-block">';
  h += '<div class="card-name-en">' + escapeHtml(item.nameEn) + '</div>';
  const cardNameAr = item.nameAr || (typeof autoTranslate === 'function' ? autoTranslate(item.nameEn) : '');
  if (cardNameAr && cardNameAr !== item.nameEn) h += '<div class="card-name-ar">' + arSpan(escapeHtml(cardNameAr)) + '</div>';
  h += '</div>';

  // Origin · Process
  if (item.origin || item.process) {
    h += '<div class="card-meta">';
    h += '<div class="card-meta-en">' + escapeHtml([item.origin, item.process].filter(Boolean).join(' · ')) + '</div>';
    const arParts = [originAr, processAr].filter(Boolean).join(' · ');
    if (arParts) h += '<div class="card-meta-ar">' + arSpan(arParts) + '</div>';
    h += '</div>';
  }

  // Altitude + Variety
  const tech = [];
  if (item.altitude) tech.push('↑ ' + escapeHtml(item.altitude));
  if (item.variety) tech.push(escapeHtml(item.variety));
  if (tech.length) {
    h += '<div class="card-tech">' + tech.join('&nbsp;&nbsp;·&nbsp;&nbsp;') + '</div>';
  }

  // Notes
  if (item.notes) {
    h += '<div class="card-notes">';
    h += '<div class="card-notes-label">Notes ' + arSpan('/ النكهات') + '</div>';
    h += '<div class="card-notes-en">' + escapeHtml(capNotes(item.notes)) + '</div>';
    if (notesAr && notesAr !== item.notes) h += '<div class="card-notes-ar">' + arSpan(notesAr) + '</div>';
    h += '</div>';
  }

  // Price
  if (price) {
    h += '<div class="card-price">' + price + ' <span class="card-price-unit">KD</span></div>';
  }

  h += '</div>'; // card-body
  h += '</div>'; // coffee-card
  return h;
}

// --- INIT ---
async function init() {
  const loadingEl = document.getElementById('loading');
  const remote = await fetchLive();

  if (remote) {
    allBranches = remote;
    // Cache for offline / fast reload
    try { localStorage.setItem('48east_live_cache', JSON.stringify(remote)); } catch (e) {}
  } else {
    // Fall back to cache
    try {
      const cached = localStorage.getItem('48east_live_cache');
      if (cached) allBranches = JSON.parse(cached);
    } catch (e) {}
  }

  // If current branch has no menu, switch to first branch that does
  if (!allBranches[currentBranch] || !allBranches[currentBranch].items || allBranches[currentBranch].items.length === 0) {
    const firstWithMenu = BRANCHES.find(b => allBranches[b.id] && allBranches[b.id].items && allBranches[b.id].items.length > 0);
    if (firstWithMenu) {
      currentBranch = firstWithMenu.id;
      localStorage.setItem('48east_live_branch', currentBranch);
    }
  }

  if (loadingEl) loadingEl.style.display = 'none';
  document.getElementById('app').style.display = 'block';

  renderBranchToggle();
  renderMenu();
}

// Auto-refresh every 60s so iPads pick up new publishes
// --- DAY / NIGHT THEME ---
// Auto: night from 6pm (18:00) to 6am (06:00); day otherwise.
// Manual toggle overrides auto for the session (persisted). A long idle
// (page reopened) re-evaluates auto unless the user explicitly set a theme.
function autoTheme() {
  const h = new Date().getHours();
  return (h >= 18 || h < 6) ? 'night' : 'day';
}
function applyTheme(theme) {
  document.documentElement.setAttribute('data-theme', theme);
  const btn = document.getElementById('themeToggle');
  if (btn) btn.textContent = theme === 'night' ? '☀️' : '🌙';
}
function initTheme() {
  let theme;
  const saved = null;
  try {
    const s = localStorage.getItem('48east_live_theme');
    const ts = localStorage.getItem('48east_live_theme_ts');
    // Manual choice sticks for 12 hours, then we fall back to auto
    if (s && ts && (Date.now() - Number(ts)) < 12 * 3600 * 1000) theme = s;
  } catch (e) {}
  if (!theme) theme = autoTheme();
  applyTheme(theme);

  const btn = document.getElementById('themeToggle');
  if (btn) {
    btn.addEventListener('click', () => {
      const current = document.documentElement.getAttribute('data-theme');
      const next = current === 'night' ? 'day' : 'night';
      applyTheme(next);
      try {
        localStorage.setItem('48east_live_theme', next);
        localStorage.setItem('48east_live_theme_ts', String(Date.now()));
      } catch (e) {}
    });
  }

  // Re-check auto theme every 10 min (only if no recent manual override)
  setInterval(() => {
    try {
      const ts = localStorage.getItem('48east_live_theme_ts');
      if (ts && (Date.now() - Number(ts)) < 12 * 3600 * 1000) return; // manual still active
    } catch (e) {}
    applyTheme(autoTheme());
  }, 600000);
}

setInterval(async () => {
  const remote = await fetchLive();
  if (remote) {
    allBranches = remote;
    try { localStorage.setItem('48east_live_cache', JSON.stringify(remote)); } catch (e) {}
    renderBranchToggle();
    renderMenu();
  }
}, 60000);

initTheme();
init();